export default class Movie {
    constructor() {
        this.init();
    }

    init() {
        this.YOUTUBE_URL = "//www.youtube.com/embed/";
        this.YOUTUBE_OPTION = "?playsinline=1&autoplay=1";

        this.modal = document.querySelector(".js-moviemodal");

        if (this.modal) {
            this.movie_target = document.querySelector(".js-moviemodal__iframe__target");
            this.nav = this.modal.querySelector(".js-moviemodal-nav");
            this.openButtons = [...document.querySelectorAll(".js-moviemodal_open")];
            this.navButtons = [...(this.nav?.querySelectorAll("button") || [])];

            this.ui();
        }
    }

    ui() {
        this.openButtons.forEach(($open) => {
            $open.addEventListener("click", () => {
                const id = $open.getAttribute("data-videoID");
                this.show(id);
                document.body.classList.add("-inmodal");
            });
        });

        this.navButtons.forEach((button) => {
            button.addEventListener("click", () => {
                const id = button.dataset.videoId;
                if (this.activeVideoId !== id) this.show(id);
            });
        });

        this.modal.querySelector(".js-modal-close").addEventListener("click", () => this.close());

        // 背景クリックで閉じる(動画iframe上のクリックは除外 = youtubeはそのまま再生)
        this.modal.addEventListener("click", (e) => {
            if (e.target.closest(".js-moviemodal-content") || e.target.closest(".js-modal-close")) return;
            this.close();
        });
    }

    close() {
        this.hide();

        const activeModal = document.querySelector(".js-modal.-active");
        if (!activeModal) {
            document.body.classList.remove("-inmodal");
        }
    }

    show(youtubeId) {
        const iframe = document.createElement("iframe");
        iframe.src = this.YOUTUBE_URL + encodeURIComponent(youtubeId) + this.YOUTUBE_OPTION;
        iframe.title = this.navButtons.find((button) => button.dataset.videoId === youtubeId)?.textContent || "YouTube video";
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("allow", "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture");
        iframe.setAttribute("allowfullscreen", "");
        this.movie_target.replaceChildren(iframe);
        this.activeVideoId = youtubeId;
        this.navButtons.forEach((button) => {
            const active = button.dataset.videoId === youtubeId;
            button.classList.toggle("-active", active);
            button.setAttribute("aria-pressed", String(active));
        });
        this.modal.classList.add("-active");
    }

    hide() {
        this.movie_target.innerHTML = "";
        this.activeVideoId = null;
        this.modal.classList.remove("-active");
    }
}
